import React, { Component } from "react";
import { Button, Dropdown as AntdDropdown, Menu } from "antd";
import { CaretDownOutlined, WarningFilled } from "@ant-design/icons";
export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.value ? props.value : props.title,
      titleColor: "colorTitleFirst",
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { menu, value } = this.props;
    if (menu.length !== newProps.menu.length) {
      if (value) {
        const findIndex = newProps.menu.findIndex(
          (item) => item.code === value
        );
        if (findIndex !== -1) {
          this.setState({
            title: newProps.menu[findIndex].name,
            titleColor: "colorTitleChosen",
          });
        }
      }
    }

    if (value !== newProps.value) {
      const findIndex = newProps.menu.findIndex(
        (item) => item.code === newProps.value
      );
      if (findIndex !== -1) {
        this.setState({
          title: newProps.menu[findIndex].name,
          titleColor: "colorTitleChosen",
        });
      } else {
        this.setState({ title: this.props.title });
      }
    }
  }

  menuRender = () => {
    const { menu } = this.props;
    return (
      <Menu className="dropdown">
        {menu.map((value, index) => {
          return (
            <Menu.Item
              style={{
                borderBottom: value.warning ? "0.3px solid #d9d9d9" : "none",
                ...(value.color && { background: value.color }),
              }}
              onClick={() => {
                this.setState({
                  title: value.name,
                  titleColor: "colorTitleChosen",
                });
                this.props.select && this.props.select(value);
              }}
              key={index.toString()}
            >
              <div>{value.name}</div>
              {value.warning && (
                <div style={styles.contract_contained}>
                  <WarningFilled style={styles.icon} />
                  Nhiên liệu này có thể không phù hợp với loại xe đã chọn.
                </div>
              )}
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };
  render() {
    const { title, titleColor } = this.state;
    return (
      <AntdDropdown
        disabled={this.props.disabled}
        getPopupContainer={(node) => {
          if (node) {
            return node.parentNode;
          }
          return document.body;
        }}
        trigger={["click"]}
        overlay={this.menuRender()}
        placement="bottomCenter"
      >
        <Button
          className={this.props.className}
          style={{ height: 30, borderRadius: 5 }}
        >
          <span className={titleColor}>{title}</span>{" "}
          <CaretDownOutlined style={{ color: "#d20a30" }} />
        </Button>
      </AntdDropdown>
    );
  }
}

export const styles = {
  contract_contained: {
    fontSize: "10px",
    color: "#f4bc2b",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  icon: {
    fontSize: "0.9em",
    marginRight: 3,
    color: "#f4bc2b",
  },
};
